// @flow

import {GET} from '../helpers/request';

import type {Project} from './purchaseReportView';
import type {
  ErrorDto,
} from '../dtos';
import type {Exact} from '../reducers/configTemplateView';

export const DATA_REQUEST = '@siteManagerReport/DATA_REQUEST';
export const DATA_SUCCESS = '@siteManagerReport/DATA_SUCCESS';
export const DATA_FAILURE = '@siteManagerReport/DATA_FAILURE';

export const FILTER = '@siteManagerReport/FILTER';

type SiteManagerDataRequestAction = {
  type: '@siteManagerReport/DATA_REQUEST'
};

type SiteManagerDataSuccessAction = {
  type: '@siteManagerReport/DATA_SUCCESS',
  projects: Project[]
};

type SiteManagerDataFailureAction = {
  type: '@siteManagerReport/DATA_FAILURE',
  error: ErrorDto
};

type SiteManagerFilterAction = {
  type: '@siteManagerReport/FILTER',
  apartmentIds: number[],
  projectId: ?number,
  includePlans: boolean,
};

export type SiteManagerReportAction
  = SiteManagerDataRequestAction
  | SiteManagerDataSuccessAction
  | SiteManagerDataFailureAction
  | SiteManagerFilterAction;

export const dataRequest = (): Exact<SiteManagerDataRequestAction> => ({
  type: DATA_REQUEST,
});

export const dataSuccess = (projects: Project[]): Exact<SiteManagerDataSuccessAction> => ({
  type: DATA_SUCCESS,
  projects,
});

export const dataError = (error: ErrorDto): Exact<SiteManagerDataFailureAction> => ({
  type: DATA_FAILURE,
  error,
});

export const applyFilter = (apartmentIds: number[], projectId: ?number, includePlans: boolean): Exact<SiteManagerFilterAction> => ({
  type: FILTER,
  apartmentIds,
  projectId,
  includePlans,
});

export const fetchData = () => async (dispatch: Dispatch<SiteManagerReportAction>) => {
  dispatch(dataRequest());
  try {
    const projects = await GET({endpoint: '/dataexports/sitemanagerreport'}, dispatch);
    dispatch(dataSuccess(projects));
  } catch (err) {
    dispatch(dataError(err));
  }
};



// WEBPACK FOOTER //
// ./src/actions/siteManagerReportView.js